import React from 'react';
import Image from 'next/image';

interface StatsCardProps {
  number: string | number;
  title: string | string[];
  icon?: React.ReactNode;
  iconUrl?: string; // URL do ícone vindo da API
  circleColor?: string;
  accentColor?: string;
  className?: string;
}

export const StatsCard: React.FC<StatsCardProps> = ({
  number,
  title,
  icon,
  iconUrl,
  circleColor = 'bg-emerald-500',
  accentColor = 'bg-yellow-300',
  className = ''
}) => {
  // Converte o título para array se for string
  const titleLines = Array.isArray(title) ? title : [title];

  // Calcula o tamanho do texto baseado no comprimento do número
  const numberStr = String(number);
  const numberLength = numberStr.length;

  // Ajusta o tamanho do texto conforme o comprimento do número
  const getNumberSizeClass = () => {
    if (numberLength >= 6) {
      return 'text-2xl sm:text-3xl md:text-4xl';
    } else if (numberLength >= 4) {
      return 'text-3xl sm:text-4xl md:text-5xl';
    }
    return 'text-4xl sm:text-5xl md:text-6xl';
  };

  return (
    <div className={`w-full min-w-[180px] sm:min-w-[200px] md:min-w-[224px] max-w-[280px] flex flex-col items-center ${className}`}>
      {/* Círculo com ícone */}
      <div className={`w-16 h-16 sm:w-18 sm:h-18 md:w-20 md:h-20 ${circleColor} rounded-full flex items-center justify-center -mb-6 sm:-mb-7 md:-mb-8 flex-shrink-0 z-10`}>
        {iconUrl ? (
          <Image
            src={iconUrl}
            alt="Ícone"
            width={40}
            height={40}
            className="object-contain w-8 h-8 sm:w-9 sm:h-9 md:w-10 md:h-10"
          />
        ) : (
          icon
        )}
      </div>

      {/* Card de fundo com conteúdo */}
      <div className="w-full h-auto min-h-[200px] sm:min-h-[220px] md:min-h-[240px] bg-white/30 rounded-2xl md:rounded-3xl shadow-[0px_8.5px_20.3px_0px_rgba(139,141,142,0.15)] px-3 sm:px-4 pt-8 sm:pt-9 md:pt-10 pb-4 sm:pb-5 md:pb-6 flex flex-col items-center justify-center gap-3 sm:gap-4">
        {/* Número */}
        <div className={`text-gray-100 ${getNumberSizeClass()} font-light font-rubik text-center break-words max-w-full px-2`}>
          {number}
        </div>

        {/* Retângulo de destaque */}
        <div className={`w-7 sm:w-8 md:w-9 h-[5px] sm:h-[6px] md:h-[7px] rounded-full ${accentColor}`} />

        {/* Título */}
        <div className="text-center text-gray-100 text-sm sm:text-base md:text-lg font-medium font-poppins leading-snug">
          {titleLines.map((line, index) => (
            <React.Fragment key={index}>
              {line}
              {index < titleLines.length - 1 && <br />}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};

